<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('poomsae.Header') }}</h2>
                {{ $t('poomsae.Text1') }}
                <br />
                <br />
                {{ $t('poomsae.Text2') }}
                <br />
                <br />
                {{ $t('poomsae.Text3') }}
                <br />
            </div>
        </div>
        <div id="image_holder" class="imageHolder">
            <div id="gridPoomsae">
                <kendo-datasource ref="datasourcePoomsae"
                                  :transport-read-url="url"
                                  :transport-read-data-type="'jsonp'">
                </kendo-datasource>
                <kendo-grid :data-source-ref="'datasourcePoomsae'"
                            :toolbar="['pdf']"
                            :mobile="true"
                            :pdf-all-pages="true"
                            :pdf-avoid-links="true"
                            :pdf-paper-size="'A4'"
                            :pdf-margin="{ top: '2cm', left: '1cm', right: '1cm', bottom: '1cm' }"
                            :pdf-landscape="true"
                            :pdf-repeat-headers="true"
                            :pdf-file-name="$t('poomsae.Header')"
                            :pdf-title="$t('poomsae.Header')"
                            :pdf-scale="0.8">
                    <kendo-grid-column :field="'Prim'"
                                       :title="$t('poomsae.GridColumnHeaderNumber')"></kendo-grid-column>
                    <kendo-grid-column :field="'Taeguek'"
                                       :title="$t('poomsae.GridColumnHeaderTaeguek')"></kendo-grid-column>
                    <kendo-grid-column :field="'Hyong'"
                                       :title="$t('poomsae.GridColumnHeaderHyong')"></kendo-grid-column>
                    <kendo-grid-column :field="'Relevanz'"
                                       :title="$t('poomsae.GridColumnHeaderRelevance')"></kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
        <div class="transbox">
            <div class="transboxContent">
                <br />
                {{ $t('poomsae.Text4') }}
                <br />
                {{ $t('poomsae.Text5') }}
                <br />
                <br />
                {{ $t('poomsae.Text6') }}
                <br />
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';
    import '@progress/kendo-ui';
    import '@progress/kendo-theme-default/dist/all.css';
    import kendo from '@progress/kendo-ui';
    import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper';
    import { KendoDataSource } from '@progress/kendo-datasource-vue-wrapper';
    import config from "@/appdata/config.json";

    export default {
        components: {
            'kendo-grid': Grid,
            'kendo-grid-column': GridColumn,
            'kendo-datasource': KendoDataSource
        },
        props: {
            linkItem: String,
            myText: String,
            url: String
        },
        data: function () {
            return {
                theImage: '',
                schemaModelFields: {
                    Prim: { type: 'number', editable: false },
                    Taeguek: { validation: { required: true } },
                    Hyong: { validation: { required: true } },
                    Relevanz: { validation: { required: true } }
                }
            }
        },
        computed: {
        },
        mounted() {
            window.$ = kendo.jQuery;
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        created() {
            this.url = config[0].ServiceUrl + config[0].ServiceUrlPort + "/Formen"
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>